import React from "react";
import { useFormikContext } from "formik";
import baseStyles from "../../style.module.scss";
import styles from "./style.module.scss";
import ReviewHeader from "../common/ReviewHeader";
import MultiLocationDetailRows from "../../../../../../../../components/MultiLocationDetailRows";
import { isMultipleLocations } from "../../../../../../../../../components/helper/helper";

function CrossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.854 12.1463C12.9005 12.1927 12.9373 12.2479 12.9625 12.3086C12.9876 12.3693 13.0006 12.4343 13.0006 12.5C13.0006 12.5657 12.9876 12.6308 12.9625 12.6915C12.9373 12.7522 12.9005 12.8073 12.854 12.8538C12.8076 12.9002 12.7524 12.9371 12.6917 12.9622C12.631 12.9874 12.566 13.0003 12.5003 13.0003C12.4346 13.0003 12.3695 12.9874 12.3088 12.9622C12.2481 12.9371 12.193 12.9002 12.1465 12.8538L8.00028 8.70691L3.85403 12.8538C3.76021 12.9476 3.63296 13.0003 3.50028 13.0003C3.3676 13.0003 3.24035 12.9476 3.14653 12.8538C3.05271 12.76 3 12.6327 3 12.5C3 12.3674 3.05271 12.2401 3.14653 12.1463L7.2934 8.00003L3.14653 3.85378C3.05271 3.75996 3 3.63272 3 3.50003C3 3.36735 3.05271 3.2401 3.14653 3.14628C3.24035 3.05246 3.3676 2.99976 3.50028 2.99976C3.63296 2.99976 3.76021 3.05246 3.85403 3.14628L8.00028 7.29316L12.1465 3.14628C12.2403 3.05246 12.3676 2.99976 12.5003 2.99976C12.633 2.99976 12.7602 3.05246 12.854 3.14628C12.9478 3.2401 13.0006 3.36735 13.0006 3.50003C13.0006 3.63272 12.9478 3.75996 12.854 3.85378L8.70715 8.00003L12.854 12.1463Z"
        fill="#E03B24"
      />
    </svg>
  );
}

function CheckMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.3538 4.85378L6.35375 12.8538C6.30732 12.9003 6.25217 12.9372 6.19147 12.9623C6.13077 12.9875 6.06571 13.0004 6 13.0004C5.9343 13.0004 5.86923 12.9875 5.80853 12.9623C5.74783 12.9372 5.69269 12.9003 5.64625 12.8538L2.14625 9.35378C2.05243 9.25996 1.99973 9.13272 1.99973 9.00003C1.99973 8.86735 2.05243 8.7401 2.14625 8.64628C2.24007 8.55246 2.36732 8.49976 2.5 8.49976C2.63269 8.49976 2.75993 8.55246 2.85375 8.64628L6 11.7932L13.6463 4.14628C13.7401 4.05246 13.8673 3.99976 14 3.99976C14.1327 3.99976 14.2599 4.05246 14.3538 4.14628C14.4476 4.2401 14.5003 4.36735 14.5003 4.50003C14.5003 4.63272 14.4476 4.75996 14.3538 4.85378Z"
        fill="#37B450"
      />
    </svg>
  );
}

const BusinessProfile = ({ onEdit, isOpen, onToggle, complete, disputeRecoveryVisible = false }) => {
  const { values } = useFormikContext();

  const formatAdvertisingMethods = (methods) => {
    if (!methods || !methods.length) return "-";
    return methods
      .map((method) => method.charAt(0).toUpperCase() + method.slice(1))
      .join(", ");
  };

  const formatCurrency = (amount) => {
    if (!amount) return "-";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const SectionHeader = ({ title }) => (
    <div className={baseStyles.sectionHeader}>
      <span className={baseStyles.sectionTitle}>{title}</span>
      <div className={baseStyles.sectionLine} />
    </div>
  );

  return (
    <div
      className={`${baseStyles.reviewSectionContainer} ${styles.business_profile}`}
    >
      <ReviewHeader
        title="Business Profile"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
        complete={complete}
      />

      {isOpen && (
        <div className={baseStyles.reviewContent}>
          <div className={baseStyles.section}>
            <SectionHeader title="PRODUCTS AND SERVICES" />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Products or Services
                </div>
                <div className={baseStyles.detailValue}>
                  {values.product_service_description || "-"}
                </div>
              </div>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Advertising Methods
                </div>
                <div className={baseStyles.detailValue}>
                  {formatAdvertisingMethods(values.prod_advertise_description)}
                </div>
              </div>
            </div>
          </div>

          <div className={baseStyles.section}>
            <SectionHeader title="BUSINESS COMPLIANCE" />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Are there 3rd party application involved with your payment
                  process?
                </div>
                <div className={baseStyles.detailValue}>
                  <div className={styles.booleanContainer}>
                    {values.is_thirdparty_involved === "yes" ? (
                      <CheckMark />
                    ) : (
                      <CrossIcon />
                    )}
                    <span>
                      {values.is_thirdparty_involved === "yes" ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>

              {values.is_thirdparty_involved === "yes" && (
                <div className={baseStyles.detailItem}>
                  <div className={baseStyles.detailLabel}>
                    3rd party application involved description
                  </div>
                  <div className={baseStyles.detailValue}>
                    <div className={styles.details}>
                      {values.thirdparty_involved_description}
                    </div>
                  </div>
                </div>
              )}

              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>PCI Compliant</div>
                <div className={baseStyles.detailValue}>
                  <div className={styles.booleanContainer}>
                    {values.pci_complaint === "yes" ? (
                      <CheckMark />
                    ) : (
                      <CrossIcon />
                    )}
                    <span>{values.pci_complaint === "yes" ? "Yes" : "No"}</span>
                  </div>
                </div>
              </div>

              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Terminated as a VISA/MasterCard/Discover/AMEX merchant
                </div>
                <div className={baseStyles.detailValue}>
                  <div className={styles.booleanContainer}>
                    {values.terminated_as_vmdax === "yes" ? (
                      <CheckMark />
                    ) : (
                      <CrossIcon />
                    )}
                    <span>
                      {values.terminated_as_vmdax === "yes" ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>

              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Prior data compromise investigations
                </div>
                <div className={baseStyles.detailValue}>
                  <div className={styles.booleanContainer}>
                    {values.prior_data_compromise_investigation === "yes" ? (
                      <CheckMark />
                    ) : (
                      <CrossIcon />
                    )}
                    <span>
                      {values.prior_data_compromise_investigation === "yes"
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>
                </div>
              </div>

              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>Visa Risk Programs</div>
                <div className={baseStyles.detailValue}>
                  <div className={styles.booleanContainer}>
                    {values.identified_visa_risk_program === "yes" ? (
                      <CheckMark />
                    ) : (
                      <CrossIcon />
                    )}
                    <span>
                      {values.identified_visa_risk_program === "yes"
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>
                </div>
              </div>

              {values.identified_visa_risk_program === "yes" && (
                <div className={baseStyles.detailItem}>
                  <div className={baseStyles.detailLabel}>
                    Visa Risk Programs Description
                  </div>
                  <div className={baseStyles.detailValue}>
                    <div className={styles.details}>
                      {values.visa_risk_program_desc}
                    </div>
                  </div>
                </div>
              )}

              {disputeRecoveryVisible && (
                <div className={baseStyles.detailItem}>
                  <div className={baseStyles.detailLabel}>
                    Dispute Recovery Program
                  </div>
                  <div className={baseStyles.detailValue}>
                    <div className={styles.booleanContainer}>
                      {values.dispute_recovery_program ? (
                        <CheckMark />
                      ) : (
                        <CrossIcon />
                      )}
                      <span>
                        {values.dispute_recovery_program ? "Opted In" : "Opted Out"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={baseStyles.section}>
            <SectionHeader title="Multiple locations" />
            <div className={baseStyles.detailsGrid}>
              <div className={baseStyles.detailItem}>
                <div className={baseStyles.detailLabel}>
                  Multiple locations
                </div>
                <div className={baseStyles.detailValue}>
                  {values.is_multiple_locations === "yes" ? (
                    <CheckMark />
                  ) : (
                    <CrossIcon />
                  )}
                  <span>
                    {values.is_multiple_locations === "yes" ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>

            {isMultipleLocations(values.is_multiple_locations) && (
              <div className={baseStyles.detailsGrid}>
                <MultiLocationDetailRows
                  multiMerchant={values.multi_merchant}
                  multiMerchantOf={values.multi_merchant_of}
                  additionalLocation={values.additional_location}
                  additionalLocationOf={values.additional_location_of}
                  itemClassName={baseStyles.detailItem}
                  labelClassName={baseStyles.detailLabel}
                  valueClassName={baseStyles.detailValue}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessProfile;
